import { motion } from "framer-motion";

const values = [
  { title: "Confianza", desc: "Verificamos y respaldamos cada perfil." },
  { title: "Excelencia", desc: "Calidad por encima de cantidad." },
  { title: "Transparencia", desc: "Información clara y honesta." },
  { title: "Humanidad", desc: "Personas conectando con personas." },
  { title: "Innovación", desc: "Tecnología al servicio de la experiencia." },
];

export default function PurposeValuesBlock() {
  return (
    <section
      className="py-28 text-zinc-700 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/img/quienesSomos/oficina.jpeg')" }}
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-serif mb-6 text-zinc-900">Nuestro propósito</h2>
        <p className="max-w-2xl mx-auto text-zinc/80 mb-16">
          Elevar la forma en que las personas acceden a servicios profesionales,
          combinando tecnología, confianza y enfoque humano.
        </p>

        <div className="grid md:grid-cols-3 gap-10">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="relative p-8 rounded-xl shadow-lg shadow-zinc-700 border-b-2 border-r-4 border hover:border-teal-100 border-zinc-200 bg-zinc/10 hover:bg-zinc/80 hover:backdrop-blur-3xl hover:shadow-lg"
              initial={{ opacity: 0, y: 30 }}   // empieza un poco más abajo
              whileInView={{ opacity: 1, y: 0 }} // sube suavemente
              transition={{ duration: 0.8, delay: index * 0.15 }} // animación más lenta y suave
            >
              <h3 className="font-semibold mb-3 text-zinc-900">{value.title}</h3>
              <p className="text-zinc/90 text-sm">{value.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
